import React from "react";
import backgroundGradient from "../assets/images/background-gradient-mobile.svg";
import logo from "../assets/images/logo.png";
import heroArt from "../assets/images/hero-art.png";
import stylesGlobal from "../styles/stylesHeroGlobal";
import stylesMobile from "../styles/stylesHeroMobile";
import { card1Animation, card2Animation } from "../animations/heroCardAnimations";
import card1Gradient from "../assets/images/gradient-card-1.svg";
import card2Gradient from "../assets/images/gradient-card-2.svg";
import { card1Frames } from "../animations/heroCardAnimations";
import useHeroLogic from "../hooks/useHeroLogic";

function HeroMobile() {
  const { card1CurrentFrame, heroRef } = useHeroLogic();

  return (
    <section id="hero" ref={heroRef}  style={{ ...stylesGlobal.heroContainer, ...stylesMobile.heroContainerMobile }}>
      <img src={backgroundGradient} alt="Background Gradient" style={stylesMobile.backgroundMobile} />

      <div style={stylesMobile.cardsContainer}>
          
          <div style={stylesMobile.card1Placeholder}>
            <img
              src={card1Gradient}
              alt="Card Gradient"
              style={stylesMobile.cardGradient}
            />

            <div style={stylesMobile.cardBlur}></div>

            <img
              alt="Card 1 Animation"
              style={{
                ...stylesMobile.animatedImage,
                ...card2Animation,
              }}
            />
          </div>
          
          <div style={stylesMobile.card2Placeholder}>
            <img
              src={card2Gradient}
              alt="Card Gradient"
              style={stylesMobile.cardGradient}
            />

            <div style={stylesMobile.cardBlur}></div>

            <img
              src={card1Frames[card1CurrentFrame]}
              alt="Card 1 Animation"
              style={stylesMobile.animatedImage}
            />
          </div>
      </div>

      <div style={stylesMobile.contentContainer}>
        <img src={logo} alt="Logo" style={stylesMobile.logo} />

        <h1 style={stylesMobile.heading}>
          Soluções digitais que <span className="highlight">impulsionam</span> o seu negócio
        </h1>

        <p style={stylesMobile.subheading}>
          Aceleramos sua modernização com <span style={stylesMobile.subheadingHighlight}>estratégia</span>,
          <span style={stylesMobile.subheadingHighlight}>design</span> e <span style={stylesMobile.subheadingHighlight}>desenvolvimento</span> sob medida.
        </p>

        <img src={heroArt} alt="Hero Art" style={stylesMobile.heroArt} />
      </div>
    </section>
  );
}

export default HeroMobile;
